import { render, staticRenderFns } from "./EffectFeedbackModal.vue?vue&type=template&id=bf0025fc&scoped=true"
import script from "./EffectFeedbackModal.vue?vue&type=script&lang=js"
export * from "./EffectFeedbackModal.vue?vue&type=script&lang=js"
import style0 from "./EffectFeedbackModal.vue?vue&type=style&index=0&id=bf0025fc&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0025fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf0025fc')) {
      api.createRecord('bf0025fc', component.options)
    } else {
      api.reload('bf0025fc', component.options)
    }
    module.hot.accept("./EffectFeedbackModal.vue?vue&type=template&id=bf0025fc&scoped=true", function () {
      api.rerender('bf0025fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/classManage/HomeSchoolCommun/components/EffectFeedbackModal.vue"
export default component.exports